import axios from "axios"

const careerDriverOrCollegeApplysUrl =
  process.env.API_URL + "/api/career/driverOrCollegeApply"

export type ApplyFormType = "Collage" | "Driver"

export interface CallboxPublicRequest {
  fullName: string
  cellular: string
  chooseCollege?: string
  address?: string
  city?: string
  id?: string
  email?: string
  hasLicense: boolean
  language: string
  sid: string
  recaptchaResponse: string
  applyFormType: ApplyFormType
  complaint?: boolean
  organization?: string
}

export interface BooleanResponseWrapper {
  custom: string
  errorCode: number /* int32 */
  errorMessage: string
  body: boolean
}
export async function postCareerForm(
  data: CallboxPublicRequest,
): Promise<BooleanResponseWrapper> {
  try {
    const response = await axios.post<BooleanResponseWrapper>(
      careerDriverOrCollegeApplysUrl,
      data,
    )
    const responseData = response.data
    // Check if body exists (false is a valid boolean)
    if (responseData.body === null || responseData.body === undefined) {
      throw new Error("Couldn't send")
    }
    return responseData
  } catch (err) {
    throw err
  }
}
